import React from "react";
import SkeletonElement from "Components/GMS/Category/Shimmer/SkeletonElement";

/*
  The delta-list BODY shimmer — what DeltaTable renders under its real header while
  a page of rows is in flight (`dataLoading`), as opposed to TableSkeletonElement,
  the whole-table placeholder for the cold load.

  Re-inked 2026-09-09 (user screenshot in dark): the bars were already DS Skeleton
  (SkeletonElement rides the primitive since the category Phase 1), so they themed —
  but every cell painted an inline `backgroundColor: "#FFFFFF"`, and the rows wore
  bootstrap's `border-1`. Result in dark: six white slabs carrying dark-ladder bars.
  Same DOM shape and geometry as before (6 rows × 4 cells, 43px, the 13/31/11/20
  padding); the grounds moved to tokens, only the FIRST cell stays sticky (all four
  were `left: 0` sticky — a copy-paste artefact that made three cells fight for the
  same pin), and the rows ride the § 223 wave so the table reads as one band sweeping
  it rather than four synchronised strips. Purely presentational — no props, no state.
*/
const CELL_STYLE: React.CSSProperties = {
  height: "43px",
  fontFamily: "Noto Sans",
  fontWeight: 400,
  padding: "13px 31px 11px 20px",
};

const ROWS = [0, 1, 2, 3, 4, 5];
const COLUMNS = [0, 1, 2, 3];

const TableBodySkeletonElement = () => (
  <>
    {ROWS.map((row) => (
      <tr key={row} className="tw-border-b tw-border-edge" data-testid="table-body-skeleton-row">
        {COLUMNS.map((col) => (
          <th
            key={col}
            className={`tw-align-middle tw-bg-surface ${col === 0 ? "tw-sticky tw-left-0" : ""}`}
            style={CELL_STYLE}
            title={""}
          >
            <SkeletonElement type="text" />
          </th>
        ))}
      </tr>
    ))}
  </>
);

export default TableBodySkeletonElement;
